class CustomDropdown {
	constructor(selector) {
		this.wrapper = document.querySelector(selector);
		if (!this.wrapper) return false;

		this.bodySelector = "[data-custom-dropdown-body]";
		this.headerSelector = "[data-custom-dropdown-header]";
		this.labelSelector = "[data-custom-dropdown-label]";
		this.listSelector = "[data-custom-dropdown-list]";
		this.itemsSelector = "[data-custom-dropdown-item]";

		this.body = this.wrapper.querySelector(this.bodySelector);
		this.header = this.wrapper.querySelector(this.headerSelector);
		this.label = this.wrapper.querySelectorAll(this.labelSelector);
		this.list = this.wrapper.querySelector(this.listSelector);
		this.items = this.wrapper.querySelectorAll(this.itemsSelector);

		this.open = false;
		this.urlParmkey = "custom_size";
		this.init();
	}

	init() {
		this.getSelectedItem();
		this.addEvents();
	}

	addEvents() {
		this.items.forEach((item) => {
			item.addEventListener("click", () => {
				this.setSelectedItem(item);
			});
		});

		this.header.addEventListener("click", () => {
			this.toggleDropdown();
		});
	}

	setSelectedItem(item) {
		if (!item) return false;
		this.items.forEach((item) => {
			item.classList.remove("selected");
		});
		item.classList.add("selected");

		const newVal = item.querySelector("input").value;
		if (newVal) {
			this.label.forEach((label) => {
				label.innerHTML = newVal;
			});
		}
		this.setUrlParam(this.urlParmkey, newVal);
		this.selectedItem = item;
	}

	openDropdown() {
		this.open = true;
		this.list.classList.add("open");
		this.header.classList.add("open");
		this.watchClicks();
	}

	closeDropdown() {
		this.open = false;
		this.list.classList.remove("open");
		this.header.classList.remove("open");
		document.removeEventListener("click", this.watchHandle);
	}

	toggleDropdown() {
		if (this.open) {
			this.closeDropdown();
		} else {
			this.openDropdown();
		}
	}

	watchClicks() {
		document.addEventListener("click", this.watchHandle);
	}

	watchHandle = (e) => {
		if (!e.target.closest(this.bodySelector)) {
			this.closeDropdown();
		}
	};

	setUrlParam(key, value) {
		const url = new URL(window.location.href);
		url.searchParams.set(encodeURIComponent(key), encodeURIComponent(value));
		window.history.replaceState({}, "", url);
	}

	getUrlParam(key) {
		const url = new URL(window.location.href);
		const encodedValue = url.searchParams.get(encodeURIComponent(key));
		return encodedValue ? decodeURIComponent(encodedValue) : null;
	}

	getSelectedItem() {
		const urlValue = this.getUrlParam(this.urlParmkey);
		if (urlValue) {
			this.items.forEach((item) => {
				const input = item.querySelector("input")
				const value = input.value;
				if (urlValue === value) {
					this.setSelectedItem(item);
					input.checked = true;
				}
			});
		}
	}
}

document.addEventListener("DOMContentLoaded", function () {
	const SizeOption = new CustomDropdown("#product-size-option");
});
